import { characters } from "@/lib/characters";

interface Props {
  tags: string[];
  onChange: (tags: string[]) => void;
}

export function CharacterQuickTags({ tags, onChange }: Props) {
  const toggle = (name: string, nameZh: string) => {
    const has = tags.includes(name) || tags.includes(nameZh);
    if (has) {
      onChange(tags.filter((t) => t !== name && t !== nameZh));
    } else {
      onChange(Array.from(new Set([...tags, name, nameZh])));
    }
  };

  return (
    <div className="flex flex-wrap gap-1.5">
      {characters.map((c) => {
        const active = tags.includes(c.name) || tags.includes(c.nameZh);
        return (
          <button
            key={c.slug}
            type="button"
            onClick={() => toggle(c.name, c.nameZh)}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium border transition-colors ${
              active
                ? "bg-primary text-primary-foreground border-primary"
                : "bg-background border-border text-muted-foreground hover:text-foreground hover:border-foreground/40"
            }`}
          >
            {c.name} <span className="opacity-70">{c.nameZh}</span>
          </button>
        );
      })}
    </div>
  );
}
